import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { deploymentFrequencyReportEntrypoint } from '@atlassian/jira-spa-apps-software-reports-deployment-frequency-report/entrypoint.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';

export const deploymentFrequencyReportPageEntrypoint = createPageEntryPoint({
	main: deploymentFrequencyReportEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});
